const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Prefixes every id in an inline SVG string and updates all internal references so
 * multiple instances of the same SVG can coexist in the DOM without clipPath/mask conflicts.
 *
 * @param {string} svgString
 * @param {string} prefix
 * @return {string}
 */
export function uniquifySvgIds(svgString, prefix) {
    if (!svgString || !prefix) {
        return svgString;
    }

    const idPattern = /\bid="([^"]+)"/g;
    const ids = new Set();
    let match;

    while ((match = idPattern.exec(svgString)) !== null) {
        ids.add(match[1]);
    }

    if (ids.size === 0) {
        return svgString;
    }

    const sortedIds = [...ids].sort((a, b) => b.length - a.length);
    let result = svgString;

    for (const id of sortedIds) {
        const newId = `${prefix}${id}`;
        const escapedId = escapeRegExp(id);

        result = result
            .replace(new RegExp(`\\bid="${escapedId}"`, 'g'), `id="${newId}"`)
            .replace(new RegExp(`url\\(#${escapedId}\\)`, 'g'), `url(#${newId})`)
            // xlink:href must be rewritten before plain href (xlink:href contains "href=").
            .replace(new RegExp(`xlink:href="#${escapedId}"`, 'g'), `xlink:href="#${newId}"`)
            .replace(new RegExp(`href="#${escapedId}"`, 'g'), `href="#${newId}"`);
    }

    return result;
}
